if (document.querySelector('#dynamicForm form .callbackDay') && document.querySelector('#dynamicForm form .callbackTime')) {	
	// Create hidden input to store date & time
	var RequestCallback = document.createElement('input');
	RequestCallback.setAttribute('type', 'hidden');
	RequestCallback.setAttribute('id', 'RequestCallback');
    RequestCallback.setAttribute('name', 'RequestCallback');
	document.querySelector('.callbackTime').appendChild(RequestCallback);

	// Update the field whenever the selection changes or clear it if either field is blank
	[document.querySelector('#dynamicForm form .callbackDay'), document.querySelector('#dynamicForm form .callbackTime')].forEach(function (field, i) {
		field.addEventListener("click", function () {
			if (document.querySelector('[name=callbackDay]:checked') != null && document.querySelector('[name=callbackTime]:checked') != null) {
				d = document.querySelector('[name=callbackDay]:checked').value;
				t = document.querySelector('[name=callbackTime]:checked').value;
				RequestCallback.value = d + ' - ' + t;
			} else {
				RequestCallback.value = '';
			}
		});
	});
}